import React from "react";
import { FormControlLabel, Checkbox, Button, Box, TextField, MenuItem } from "@material-ui/core/";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { ErrorMessage } from "../../../common/ErrorMessage";

import { useActiveProjects } from "../../projectQueries";
import { ActiveProjectsTable } from "./activeProjectsTable";

import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import { useProjectDispositions } from "../../../common/services/dispositionServices";
import { CustomerTablePi } from "../customer/CustomerTablePI";
import { useLocations } from "../../../intake/intakeQueries";
import { useQueryClient } from "react-query";
import { getTheme } from "../../../common/getLocalTheme";

export const ActiveProjectsPage = () => {
  const [archived, setArchived] = React.useState(false);
  const [isPiData, setIsPiData] = React.useState(false);
  const [defaultLocation, setdefaultLocation] = React.useState<string | number>(5)
  const { authAxios } = useFetchContext();
  const getDownloads = async (): Promise<any> => {
    const response = await authAxios.get(urls.projects.active_projects_report_download, {
      responseType: 'blob'
    });



    const downloadUrl = URL.createObjectURL(response.data);
    let a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
    document.body.appendChild(a);
    a.click();
  };


  const {
    error: errorDispositions,
    data: dispositions,
    isLoading: isLoadingDispositions,
    isError: isErrorDispositions,
  } = useProjectDispositions();


  const {
    data = [],
    error,
    isLoading,
    isError,
    isSuccess,
  } = useActiveProjects(archived, defaultLocation);

  const {
    error: errorLocations,
    data: locations,
    isLoading: isLoadingLocations,
    isError: isErrorLocations,
  } = useLocations();

  function viewChinesData(): void {
    if (isPiData) {
      setIsPiData(false);
    } else {
      setIsPiData(true);
    }
  }

  if (isLoading || isLoadingDispositions) {
    return (
      <Backdrop open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (isError) {
    return <ErrorMessage error={error} />;
  }
  const useQuery = useQueryClient()
  const handleLocationChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedValue = event.target.value as string | number;
    console.log(selectedValue)
    setdefaultLocation(selectedValue);

  };

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={4}
      >
        <Grid item xs={4}>
          <Typography variant="h3"> Active Projects </Typography>
        </Grid>

        <Grid item xs={5} container justify="flex-end" alignItems="flex-start">
          <Grid container spacing={3} alignItems="flex-start" justify="flex-end">
            <Grid item>
              <Button variant="contained" color="primary" onClick={getDownloads}>
                Download
              </Button>
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={archived}
                    onChange={() => {
                      setArchived(!archived);
                    }}
                    name="archived"
                  />
                }
                label="View Inactive"
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="location"
                type="text"
                name="location"
                variant="outlined"
                style={{
                  width: "100%" ,
                  marginBottom: "16px",
                }}
                select
                value={defaultLocation}
                disabled={getTheme()}
                onChange={handleLocationChange}
                label="Location"
                data-testid="location"
              >
                {locations?.map((location: any) => (
                  <MenuItem key={location.id} value={location.id}>
                    {location.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {isSuccess && <ActiveProjectsTable data={data} dispositions={dispositions} />}

          <Box padding={2}></Box>
       
        </Grid>
      </Grid>
    </>
  );

}  